export default __webpack_public_path__ + "static/media/img_24.548591d6.JPG";